import React from "react"
import type { RouteObject } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { lazyPage } from "../lazyPage.tsx"
import LoginPage from "../../../LoginPage/LoginPage.tsx"
import SigningPage from "../../../SigningPage/SigningPage.tsx"
import WhatsAppLoginPage from "../../../WhatsApp/WhatsAppLoginPage/WhatsAppLoginPage.tsx"

const CheckEmailCode = lazyPage(() => import("../../../CheckEmailCode"))
const ConfirmChangeEmailPage = lazyPage(
  () => import("../../../ConfirmChangeEmailPage")
)
const CustomerUploadPage = lazyPage(
  () => import("../../../CustomerUploadPage/CustomerUploadPage.tsx")
)
const MobileAppPage = lazyPage(
  () => import("../../../MobileAppPage/MobileAppPage.tsx")
)
const NewPasswordPage = lazyPage(() => import("../../../NewPasswordPage.tsx"))
const ProjectEducationPage = lazyPage(
  () => import("../../../ProjectEducationPage/ProjectEducationPage.tsx")
)
const RestorePasswordPage = lazyPage(
  () => import("../../../RestorePasswordPage")
)
const SharedFilePage = lazyPage(
  () => import("../../../SharedFilePage/SharedFilePage.tsx")
)
const SignUpPage = lazyPage(() => import("../../../SignUpPage"))
const StartupPage = lazyPage(() => import("../../../StartupPage"))
const VerifyCodePage = lazyPage(() => import("../../../VerifyCodePage"))
// Auth routes (public)
export const authRoutes: RouteObject[] = [
  {
    // A recipient's signing link. Public like the rest of these, but for
    // somebody who has no account at all rather than somebody on their way to
    // one — so it renders no app shell and asks for no login.
    path: RoutesPaths.signing,
    element: <SigningPage />
  },
  {
    // A customer's upload link from a meeting invitation. Same public, no-app-
    // shell handling as the signing page above.
    path: RoutesPaths.customerUpload,
    element: <CustomerUploadPage />
  },
  {
    path: `${RoutesPaths.sharedFile}/:token`,
    element: <SharedFilePage />
  },
  {
    // The public, no-login customer guide page reached from a share link.
    // Same public, no-app-shell handling as the routes above — the token
    // travels in the URL fragment, never the path.
    path: RoutesPaths.projectEducation,
    element: <ProjectEducationPage />
  },
  {
    index: true,
    element: <StartupPage />
  },
  {
    path: "login",
    element: <LoginPage />
  },
  {
    path: "login/:hash",
    element: <LoginPage />
  },
  {
    path: RoutesPaths.auth.mobileApp,
    element: <MobileAppPage />
  },
  {
    path: RoutesPaths.auth.whatsapp_login,
    element: <WhatsAppLoginPage />
  },
  {
    path: "confirm-email-change/:token",
    element: <ConfirmChangeEmailPage />
  },
  {
    path: "sign-up",
    element: <SignUpPage />
  },
  {
    path: "add-email",
    element: <SignUpPage />
  },
  {
    path: "sign-up/confirm/:hash",
    element: <CheckEmailCode />
  },
  {
    path: "restore-password",
    element: <RestorePasswordPage />
  },
  {
    path: "verify-code",
    element: <VerifyCodePage />
  },
  {
    path: "restore-password/:hash",
    element: <NewPasswordPage />
  }
]
